//! ir 是否不需要动态显示  ix 是否是flex布局
//距离底部多少触发
let bottomHeight = -80

//页面高度
let fullHeight = 0
//refs列表
let refsList = []
//refsTop列表
let topList = []
//出现的元素
let showDom = {}
//是否开启
let isScroll = false
//refs数量
let refsNumber = 0
//是否可以访问
let isThrottle = true
//更改dom
const setShowDom = index => {
    showDom = {
        index: index,
        top: topList[index] - fullHeight
    }
}
const scrollFun = e => {
    //没有数据了 或者 在节流期间
    if (!isScroll || !isThrottle) return false
    //节流
    isThrottle = false
    //固定时间内不让进来
    setTimeout(() => (isThrottle = true), 20)
    //滚动条高度
    const scrollTop = e.srcElement.scrollingElement.scrollTop
    //判断是否出现在可视范围
    if (showDom.top - scrollTop < bottomHeight) {
        //dom的坐标
        let showDomIndex = showDom.index
        let dom = refsList[showDomIndex]
        //改变状态
        dom.style.display =
            dom.getAttribute("class").indexOf("ix") != -1 ? "flex" : "block"
        //判断是否是最后一个
        if (showDomIndex === refsNumber - 1) {
            isScroll = false
        }
        //改变showDom
        setShowDom(showDomIndex + 1)
    }
}
export default {
    mounted() {
        //页面初始监听滚动条事件
        window.addEventListener("scroll", scrollFun, true)
        //获取页面可视高度
        fullHeight = document.documentElement.clientHeight
        //当页面size改变时 更改size
        window.onresize = () => {
            return (() => {
                fullHeight = document.documentElement.clientHeigh
            })()
        }
    },
    watch: {
        "$store.state.refsList": function(newList) {
            //ref数组
            let list = []
            //取数据
            for (const key in newList) {
                let newListData = newList[key]
                let newListDetail =
                    newListData.$el ||
                    (newListData.length ? newListData[0] : newListData)
                newListDetail.getAttribute("class").indexOf("ir") === -1 &&
                    list.push(newListDetail)
            }
            //ref数量
            refsNumber = list.length
            //关闭监听 并不往下走
            if (refsNumber === 0) return false, (isScroll = false)
            isScroll = true
            //从新排序
            let sortList = list.sort(
                (a, b) =>
                    a.getBoundingClientRect().top >
                    b.getBoundingClientRect().top
            )

            //获取位置
            topList = sortList.map(item => item.getBoundingClientRect().top)
            //获取从新排序
            refsList = sortList
            //要出现的元素
            setShowDom(0)
            //list全部变成none
            list.forEach(item => (item.style.display = "none"))
            this.$nextTick(() => {
                while (showDom.top <= 0) {
                    let showDomIndex = showDom.index

                    let domDetail = refsList[showDomIndex]

                    domDetail.style.display =
                        domDetail.getAttribute("class").indexOf("ix") != -1
                            ? "flex"
                            : "block"

                    setShowDom(showDomIndex + 1)
                }
            })
        }
    },
    computed: {
        getRouteMeta() {
            return this.$route
        }
    }
}



// WEBPACK FOOTER //
// ./src/common/js/scroll.js